import { forwardRef } from "react"

import Input from './Input.jsx'

const Email = forwardRef(function Email({...props}, ref) {
  return (
    <Input
      ref={ref}
      placeholder={"name@company.com"}
      autoComplete={"email"}
      type={"email"}
      {...props}
    />
  )
})

export default Email;
